export default {"src":"/uk/_next/static/media/green-bullet-checkmark.fca486f8.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};